import React, { useState, memo } from 'react';
import { connect } from 'react-redux';

import Popups from '../../components/Popup';
import { usePopupContext } from '../../contexts/PopupContext';

const AgreementCategoriesPopupContainer = props => {
  const { closePopup } = usePopupContext();
  const agreementCategories = props.popup.getIn(['props', 'agreementCategories']);
  const updateAgreementCategories = props.popup.getIn(['props', 'updateAgreementCategories']);
  const [children, setChildren] = useState(agreementCategories.toJS().flatMap(value => value.children));

  const handleClose = () => {
    const updatedAgreementCategories = props.agreementCategories
      .map(agreementCategory => ({
        ...agreementCategory.toJS(),
        children: children.filter(child => child.parentId === agreementCategory.get('id')),
      }))
      .filter(agreementCategory => agreementCategory.children.length > 0);

    updateAgreementCategories(updatedAgreementCategories);
    closePopup();
  };

  const handleChange = category => {
    const isExist = children.find(agreementCategory => agreementCategory.id === category.id);

    if (isExist) {
      const withoutExists = children.filter(agreementCategory => agreementCategory.id !== category.id);

      setChildren(withoutExists);
    } else {
      setChildren([
        ...children,
        {
          ...category,
          linkedAgreementBuyerId: null,
          linkedAgreementBuyerName: null,
          linkedAgreementId: null,
          linkedAgreementName: null,
        },
      ]);
    }
  };

  return (
    <Popups.AgreementCategoriesPopup
      agreementCategoriesList={props.agreementCategories.toJS()}
      initialValues={agreementCategories}
      onChange={handleChange}
      onClose={handleClose}
    />
  );
};

const mapStateToProps = state => ({
  agreementCategories: state.agreementCategories.get('data'),
});

export { AgreementCategoriesPopupContainer };
export default connect(mapStateToProps, null)(memo(AgreementCategoriesPopupContainer));
